import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Tiplist} from 'shared/models/tips/tiplist';
import {TipListDetailsRepository} from './../repositories/tip-list-details.repository';

@Injectable()
export class TipListDetailsService {

  constructor(private detailsRepository: TipListDetailsRepository) { }

  public getTiplistById(id: string): Observable<Tiplist> {
    return this.detailsRepository.getTiplistById(id);
  }

  public saveTiplist(tiplist: Tiplist): Observable<Tiplist> {
    return this.detailsRepository.saveTiplist(tiplist);
  }

  public updateTiplist(tiplist: Tiplist): Observable<Tiplist> {
    return this.detailsRepository.updateTiplist(tiplist);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/tip-list/tip-list-details/services/tip-list-details.service.ts